import { render } from "./index.vue?vue&type=template&id=70bc07e3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=70bc07e3&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=70bc07e3&lang=scss"

import exportComponent from "D:\\VueProject\\app\\app_store_static\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.38_vue@3.4.38_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bc07e3"]])

export default __exports__